//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HomeStory',

  data() {
    return {
      CDN: process.env.CDN,
    };
  },
};
